import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=ee25e6de&scoped=true&"
import script from "./AdminDetails.vue?vue&type=script&lang=js&"
export * from "./AdminDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetails.vue?vue&type=style&index=0&id=ee25e6de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee25e6de",
  null
  
)

export default component.exports